import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalDataService} from '../global-data.service';
import {AuthenticationService} from '../authentication-service.service';
import {SkySwitchSSOService} from '../skyswitch-sso.service';

@Component({
  selector: 'app-skyswitch-sso',
  templateUrl: './skyswitch-sso.component.html',
  styleUrls: ['./skyswitch-sso.component.css'],
  providers:[SkySwitchSSOService]
})

export class SkyswitchSsoComponent implements OnInit {

  private login_name: string;
  private auth_token: string;
  private refresh_token: string;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: SkySwitchSSOService, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.main();
  }

  main(): void {
    this.route.queryParams
      .subscribe(params => {
        this.login_name = params['login_name'];
        this.auth_token = params['auth_token'];
        this.refresh_token = params['refresh_token'];
      });
    this.componentService.ssoLogin(this.login_name, this.auth_token, this.refresh_token).then(this.mainSuccess.bind(this))
      .catch(this.mainFail.bind(this));
  }

  mainSuccess(result) {
    this.globalDataService.loginType = 'skyswitch';
    this.globalDataService.token = result.token;
    this.globalDataService.refreshToken = result.refresh_token;
    this.globalDataService.skyLogin = result.sky_login;
    this.globalDataService.role = result.role;
    this.router.navigate(['/create/order']);
  }

  mainFail(e) {
    this.router.navigate(['/pbx/login']);
  }

}



// WEBPACK FOOTER //
// ./src/app/skyswitch-sso/skyswitch-sso.component.ts